/**
 * Wires every `[data-wishlist-toggle]` heart button (product cards, the PDP
 * gallery, the wishlist page) to the shared assets/wishlist.js store via
 * delegated document listeners, so it works regardless of how many buttons
 * render or when they're added to the DOM (Section Rendering replaces,
 * dynamically loaded cards, etc). Also keeps the header's `[data-wishlist-
 * count]` badge in sync with the saved count.
 *
 * DOM contract: each button carries `data-product-id` and reflects state via
 * `aria-pressed`. Requires assets/wishlist.js to be loaded first.
 */
function syncWishlistButtons() {
  if (!window.VellumWishlist) return;

  document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
    const isSaved = window.VellumWishlist.isWishlisted(button.dataset.productId);
    button.setAttribute('aria-pressed', String(isSaved));
  });

  const count = window.VellumWishlist.readWishlist().length;
  document.querySelectorAll('[data-wishlist-count]').forEach((badge) => {
    badge.hidden = count === 0;
    badge.textContent = count;
  });
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-wishlist-toggle]');
  if (!button || !window.VellumWishlist) return;

  const isSaved = window.VellumWishlist.toggleWishlist(button.dataset.productId);
  button.setAttribute('aria-pressed', String(isSaved));
});

window.addEventListener('vellum:wishlist-updated', syncWishlistButtons);
window.addEventListener('vellum:cards-updated', syncWishlistButtons);
window.addEventListener('vellum:cart-updated', syncWishlistButtons);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncWishlistButtons);
} else {
  syncWishlistButtons();
}
